import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { DEVE_ESCOLHER_MODALIDADE, EscolhaModalidadeService } from '../shared/services/escolha-modalidade.service';

/**
 * Este guard deve estar em todas as telas do sistema, com exceção das telas públicas.
 * 
 * O usuário não deve poder utilizar o sistema sem antes escolher a modalidade.
 * 
 * @author iuryl
 */
@Injectable()
export class EscolhaModalidadeGuard implements CanActivate {

    constructor(
        private escolhaModalidadeService: EscolhaModalidadeService,
        private router: Router,
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.escolhaModalidadeService.escolhaModalidade$.pipe(
            filter(modalidade => !!modalidade),
            take(1),
            map(m => {
                if(m === DEVE_ESCOLHER_MODALIDADE) {
                    this.router.navigate(['escolha-modalidade'], {queryParams: {returnUrl: state.url}});
                    return false;
                }

                return true;
            })
        );
    }

}
